import React, { useState, forwardRef } from "react";
import DatePicker from "react-datepicker";
import { Field } from "react-final-form";
import InputLabel from "@mui/material/InputLabel";
import "react-datepicker/dist/react-datepicker.css";
import OutlinedInput from "@mui/material/OutlinedInput";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";


export default function UiDatePicker(props) {
     const [startDate, setStartDate] = useState(null);

     React.useEffect(() => {
          if (props.value) {
               setStartDate(datePickerToGmtFormat(props.value));
          }
     }, [props.value]);

     const CustomInput = React.forwardRef((props, ref) => (
          <>
               <InputLabel>{props.label}</InputLabel>
               <OutlinedInput
                    id="search"
                    type="text"
                    label={props.label}
                    fullWidth
                    {...props}
                    ref={ref}
               />
          </>
     ));

     return (
          <>

               <>
                    <div className="sba-date-range-picker">
                         <FormControl
                              sx={{ mb: 2 }}
                              variant="outlined"
                              fullWidth
                              error={props.error}
                         >
                              <DatePicker
                                   selected={startDate}
                                   className="red-border"
                                   customInput={
                                        <CustomInput
                                             label={props.label}
                                        />
                                   }
                                   onChange={(date) => {
                                        setStartDate(date);
                                      
                                   }}
                                   isClearable={false}
                              />

                              {props.error && (
                                   <FormHelperText className="component-error-text">
                                        {props.error}
                                   </FormHelperText>
                              )}
                         </FormControl>
                    </div>
               </>

          </>
     );
}
